import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import AutoScrollToTop from 'components/AutoScrollToTop'
import { Nav } from 'components/Nav'
import { Footer } from 'components/Footer'
import { Shortcut } from 'components/Shortcut'
import HomePage from 'pages/HomePage'
import Production from 'pages/Production'
import About from 'pages/About'
import Support from 'pages/Support'
import Solution from 'pages/Solution'
import { NotFound } from 'components/NotFound'
import { useState } from 'react'

function App() {
  const [isScroll, setIsScroll] = useState(false);
  const [isShowWebsite, setIsShowWebsite] = useState(false);

  const onScroll = (flag) => {
    setIsScroll(flag);
  }

  const changeShowWebsite = (flag) => {
    setIsShowWebsite(flag);
  }

  return (
    <div className="app">
      <Router>
        <AutoScrollToTop>
          <Nav isScroll={isScroll} onScroll={onScroll}/>
          <Switch>
            <Route exact path="/">
              <HomePage />
            </Route>
            <Route exact path="/production">
              <Production />
            </Route>
            <Route exact path="/about">
              <About />
            </Route>
            <Route exact path="/support">
              <Support />
            </Route>
            <Route exact path="/solution">
              <Solution />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
          <Shortcut isScroll={isScroll} />
          <Footer />
        </AutoScrollToTop>
      </Router>
    </div>
  )
}

export default App
